import { render, staticRenderFns } from "./AdminOrders.vue?vue&type=template&id=79483a1b"
import script from "./AdminOrders.vue?vue&type=script&lang=js"
export * from "./AdminOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79483a1b')) {
      api.createRecord('79483a1b', component.options)
    } else {
      api.reload('79483a1b', component.options)
    }
    module.hot.accept("./AdminOrders.vue?vue&type=template&id=79483a1b", function () {
      api.rerender('79483a1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminOrders.vue"
export default component.exports